var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnionclipboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5911 4.48378H8.27018C9.65216 4.48378 9.99722 3.80884 10.0834 3.2002C11.6553 3.38835 12.4562 4.09361 12.4562 6.66049V10.6791C12.4562 13.1572 11.9673 14.1954 8.93995 14.1954H4.92133C1.89398 14.1954 1.40504 13.1572 1.40504 10.6791V6.66049C1.40504 4.08561 2.21104 3.38397 3.79264 3.19845C4.01311 4.48378 5.02079 4.48378 5.5911 4.48378ZM3.77617 2.19507C3.957 0.800049 5.005 0.800049 5.5911 0.800049H8.27018C8.85548 0.800049 9.90143 0.800049 10.0844 2.18937C12.4778 2.45428 13.4609 3.77944 13.4609 6.65379V10.6724C13.4609 13.472 12.7041 15.2 8.93995 15.2H4.92133C1.15723 15.2 0.400391 13.472 0.400391 10.6791V6.66049C0.400391 3.78012 1.38332 2.45458 3.77617 2.19507ZM4.7539 2.63524C4.75482 1.8047 4.9298 1.8047 5.5911 1.8047H8.27018C8.92978 1.8047 9.10555 1.8047 9.10738 2.62881C9.1066 2.64506 9.10661 2.66119 9.10739 2.67716C9.10712 3.31118 9.09236 3.47913 8.27018 3.47913H5.5911C4.93876 3.47913 4.75965 3.47913 4.75403 2.6819C4.75468 2.66653 4.75464 2.65097 4.7539 2.63524Z",
    fill: "#5A5C61"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnionclipboard);
export default __webpack_public_path__ + "static/media/Unionclipboard.2a457f70fc99e467aa10e0a32be9cd70.svg";
export { ForwardRef as ReactComponent };